export const getParticipant = (participants: any, type = 'Mieter') =>
    participants?.find((participant: any) => participant?.typSnippet?.name === type)?.kontakt;
